import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getLanguageFromFilePath = (filePath: string): string => {
  if (!filePath) return 'text';
  const extension = filePath.split('.').pop()?.toLowerCase();
  switch (extension) {
    case 'ts':
    case 'tsx':
      return 'typescript';
    case 'js':
    case 'jsx':
      return 'javascript';
    case 'json':
      return 'json';
    case 'css':
      return 'css';
    case 'html':
      return 'html';
    case 'md':
      return 'markdown';
    case 'py':
      return 'python';
    case 'java':
      return 'java';
    case 'sh':
    case 'bash':
      return 'bash';
    case 'yml':
    case 'yaml':
      return 'yaml';
    case 'sql':
      return 'sql';
    default:
      return 'text';
  }
}

export const resolveWorkspacePath = (basePath: string, relativePath: string): string => {
  // If the relative path starts with '/', it's already absolute from the root
  if (relativePath.startsWith('/')) {
    return relativePath.substring(1);
  }

  const baseParts = basePath.split('/').slice(0, -1); // Directory of the base file
  const relativeParts = relativePath.split('/');
  
  const newPathParts = [...baseParts];

  for (const part of relativeParts) {
    if (part === '..') {
      if (newPathParts.length > 0) {
        newPathParts.pop();
      }
    } else if (part !== '.') {
      newPathParts.push(part);
    }
  }

  return newPathParts.join('/');
};